const buildSuffix = (url?: {query?: Record<string, string>, hash?: string}) => {
  const query = url?.query;
  const hash = url?.hash;
  if (!query && !hash) return '';
  const search = query ? `?${new URLSearchParams(query)}` : '';
  return `${search}${hash ? `#${hash}` : ''}`;
};

export const pagesPath = {
  "admin": {
    "listings": {
      _listingId: (listingId: string | number) => ({
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/listings/[listingId]/edit' as const, query: { listingId }, hash: url?.hash, path: `/admin/listings/${listingId}/edit${buildSuffix(url)}` })
        },
        "preview": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/listings/[listingId]/preview' as const, query: { listingId }, hash: url?.hash, path: `/admin/listings/${listingId}/preview${buildSuffix(url)}` })
        }
      }),
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/listings/new' as const, hash: url?.hash, path: `/admin/listings/new${buildSuffix(url)}` })
      },
      "schedule": {
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/listings/schedule/edit' as const, hash: url?.hash, path: `/admin/listings/schedule/edit${buildSuffix(url)}` })
        }
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/admin/listings' as const, hash: url?.hash, path: `/admin/listings${buildSuffix(url)}` })
    },
    "mypage": {
      "account": {
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/mypage/account/edit' as const, hash: url?.hash, path: `/admin/mypage/account/edit${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/mypage/account' as const, hash: url?.hash, path: `/admin/mypage/account${buildSuffix(url)}` })
      },
      "notification": {
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/mypage/notification/edit' as const, hash: url?.hash, path: `/admin/mypage/notification/edit${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/mypage/notification' as const, hash: url?.hash, path: `/admin/mypage/notification${buildSuffix(url)}` })
      },
      "official_announcements": {
        _officialAnnouncementId: (officialAnnouncementId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/mypage/official_announcements/[officialAnnouncementId]' as const, query: { officialAnnouncementId }, hash: url?.hash, path: `/admin/mypage/official_announcements/${officialAnnouncementId}${buildSuffix(url)}` })
        })
      }
    },
    "organization": {
      "activity": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/activity' as const, hash: url?.hash, path: `/admin/organization/activity${buildSuffix(url)}` })
      },
      "edit": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/edit' as const, hash: url?.hash, path: `/admin/organization/edit${buildSuffix(url)}` })
      },
      "ibow_document_request": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/ibow_document_request' as const, hash: url?.hash, path: `/admin/organization/ibow_document_request${buildSuffix(url)}` })
      },
      "import": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/import' as const, hash: url?.hash, path: `/admin/organization/import${buildSuffix(url)}` })
      },
      "invitations": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/invitations' as const, hash: url?.hash, path: `/admin/organization/invitations${buildSuffix(url)}` })
      },
      "qr_code": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/qr-code' as const, hash: url?.hash, path: `/admin/organization/qr-code${buildSuffix(url)}` })
      },
      "register_request_user": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/register_request_user' as const, hash: url?.hash, path: `/admin/organization/register_request_user${buildSuffix(url)}` })
      },
      "staffs": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization/staffs' as const, hash: url?.hash, path: `/admin/organization/staffs${buildSuffix(url)}` })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/admin/organization' as const, hash: url?.hash, path: `/admin/organization${buildSuffix(url)}` })
    },
    "partnerships": {
      "confirm": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/partnerships/confirm' as const, hash: url?.hash, path: `/admin/partnerships/confirm${buildSuffix(url)}` })
      },
      "new": {
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/partnerships/new' as const, hash: url?.hash, path: `/admin/partnerships/new${buildSuffix(url)}` })
      }
    },
    "request_cards": {
      $url: (url?: { hash?: string }) => ({ pathname: '/admin/request_cards' as const, hash: url?.hash, path: `/admin/request_cards${buildSuffix(url)}` })
    },
    "requests": {
      _requestCardId: (requestCardId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/requests/[requestCardId]' as const, query: { requestCardId }, hash: url?.hash, path: `/admin/requests/${requestCardId}${buildSuffix(url)}` })
      }),
      "thanks": {
        "history": {
          $url: (url?: { hash?: string }) => ({ pathname: '/admin/requests/thanks/history' as const, hash: url?.hash, path: `/admin/requests/thanks/history${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/admin/requests/thanks' as const, hash: url?.hash, path: `/admin/requests/thanks${buildSuffix(url)}` })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/admin/requests' as const, hash: url?.hash, path: `/admin/requests${buildSuffix(url)}` })
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/admin' as const, hash: url?.hash, path: `/admin${buildSuffix(url)}` })
  },
  "app": {
    "hospitals": {
      _portalOfficeId: (portalOfficeId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/app/hospitals/[portalOfficeId]' as const, query: { portalOfficeId }, hash: url?.hash, path: `/app/hospitals/${portalOfficeId}${buildSuffix(url)}` })
      })
    },
    "mypage": {
      "account": {
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/account/edit' as const, hash: url?.hash, path: `/app/mypage/account/edit${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/account' as const, hash: url?.hash, path: `/app/mypage/account${buildSuffix(url)}` })
      },
      "favorites": {
        $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/favorites' as const, hash: url?.hash, path: `/app/mypage/favorites${buildSuffix(url)}` })
      },
      "histories": {
        $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/histories' as const, hash: url?.hash, path: `/app/mypage/histories${buildSuffix(url)}` })
      },
      "notification": {
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/notification/edit' as const, hash: url?.hash, path: `/app/mypage/notification/edit${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/notification' as const, hash: url?.hash, path: `/app/mypage/notification${buildSuffix(url)}` })
      },
      "official_announcements": {
        _officialAnnouncementId: (officialAnnouncementId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/official_announcements/[officialAnnouncementId]' as const, query: { officialAnnouncementId }, hash: url?.hash, path: `/app/mypage/official_announcements/${officialAnnouncementId}${buildSuffix(url)}` })
        })
      },
      "organization": {
        "activity": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/organization/activity' as const, hash: url?.hash, path: `/app/mypage/organization/activity${buildSuffix(url)}` })
        },
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/organization/edit' as const, hash: url?.hash, path: `/app/mypage/organization/edit${buildSuffix(url)}` })
        },
        "invitations": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/organization/invitations' as const, hash: url?.hash, path: `/app/mypage/organization/invitations${buildSuffix(url)}` })
        },
        "staffs": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/organization/staffs' as const, hash: url?.hash, path: `/app/mypage/organization/staffs${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/mypage/organization' as const, hash: url?.hash, path: `/app/mypage/organization${buildSuffix(url)}` })
      }
    },
    "patients": {
      $url: (url?: { hash?: string }) => ({ pathname: '/app/patients' as const, hash: url?.hash, path: `/app/patients${buildSuffix(url)}` })
    },
    "portal_patients": {
      $url: (url?: { hash?: string }) => ({ pathname: '/app/portal_patients' as const, hash: url?.hash, path: `/app/portal_patients${buildSuffix(url)}` })
    },
    "request_cards": {
      $url: (url?: { hash?: string }) => ({ pathname: '/app/request_cards' as const, hash: url?.hash, path: `/app/request_cards${buildSuffix(url)}` })
    },
    "requests": {
      _requestCardId: (requestCardId: string | number) => ({
        "edit": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/[requestCardId]/edit' as const, query: { requestCardId }, hash: url?.hash, path: `/app/requests/${requestCardId}/edit${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/[requestCardId]' as const, query: { requestCardId }, hash: url?.hash, path: `/app/requests/${requestCardId}${buildSuffix(url)}` })
      }),
      "create": {
        _portalOfficeId: (portalOfficeId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/create/[portalOfficeId]' as const, query: { portalOfficeId }, hash: url?.hash, path: `/app/requests/create/${portalOfficeId}${buildSuffix(url)}` })
        })
      },
      "create_multi": {
        $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/create-multi' as const, hash: url?.hash, path: `/app/requests/create-multi${buildSuffix(url)}` })
      },
      "thanks": {
        "history": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/thanks/history' as const, hash: url?.hash, path: `/app/requests/thanks/history${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/requests/thanks' as const, hash: url?.hash, path: `/app/requests/thanks${buildSuffix(url)}` })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/app/requests' as const, hash: url?.hash, path: `/app/requests${buildSuffix(url)}` })
    },
    "stations": {
      _portalOfficeId: (portalOfficeId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/app/stations/[portalOfficeId]' as const, query: { portalOfficeId }, hash: url?.hash, path: `/app/stations/${portalOfficeId}${buildSuffix(url)}` })
      }),
      "search": {
        "word": {
          $url: (url?: { hash?: string }) => ({ pathname: '/app/stations/search/word' as const, hash: url?.hash, path: `/app/stations/search/word${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/app/stations/search' as const, hash: url?.hash, path: `/app/stations/search${buildSuffix(url)}` })
      }
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/app' as const, hash: url?.hash, path: `/app${buildSuffix(url)}` })
  },
  "maintenance": {
    $url: (url?: { hash?: string }) => ({ pathname: '/maintenance' as const, hash: url?.hash, path: `/maintenance${buildSuffix(url)}` })
  },
  "partnerships": {
    "approve": {
      _token: (token: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/partnerships/approve/[token]' as const, query: { token }, hash: url?.hash, path: `/partnerships/approve/${token}${buildSuffix(url)}` })
      })
    },
    "verify": {
      _token: (token: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/partnerships/verify/[token]' as const, query: { token }, hash: url?.hash, path: `/partnerships/verify/${token}${buildSuffix(url)}` })
      })
    }
  },
  "password_reset": {
    $url: (url?: { hash?: string }) => ({ pathname: '/password-reset' as const, hash: url?.hash, path: `/password-reset${buildSuffix(url)}` })
  },
  "public": {
    "hospitals": {
      _portalOfficeId: (portalOfficeId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/public/hospitals/[portalOfficeId]' as const, query: { portalOfficeId }, hash: url?.hash, path: `/public/hospitals/${portalOfficeId}${buildSuffix(url)}` })
      })
    },
    "official_announcements": {
      _officialAnnouncementId: (officialAnnouncementId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/public/official_announcements/[officialAnnouncementId]' as const, query: { officialAnnouncementId }, hash: url?.hash, path: `/public/official_announcements/${officialAnnouncementId}${buildSuffix(url)}` })
      })
    },
    "stations": {
      _portalOfficeId: (portalOfficeId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/public/stations/[portalOfficeId]' as const, query: { portalOfficeId }, hash: url?.hash, path: `/public/stations/${portalOfficeId}${buildSuffix(url)}` })
      }),
      "search": {
        "word": {
          $url: (url?: { hash?: string }) => ({ pathname: '/public/stations/search/word' as const, hash: url?.hash, path: `/public/stations/search/word${buildSuffix(url)}` })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/public/stations/search' as const, hash: url?.hash, path: `/public/stations/search${buildSuffix(url)}` })
      }
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/public' as const, hash: url?.hash, path: `/public${buildSuffix(url)}` })
  },
  "recept": {
    "register": {
      "portal_staff": {
        $url: (url?: { hash?: string }) => ({ pathname: '/recept/register/portal-staff' as const, hash: url?.hash, path: `/recept/register/portal-staff${buildSuffix(url)}` })
      },
      "request_user": {
        $url: (url?: { hash?: string }) => ({ pathname: '/recept/register/request-user' as const, hash: url?.hash, path: `/recept/register/request-user${buildSuffix(url)}` })
      }
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/recept' as const, hash: url?.hash, path: `/recept${buildSuffix(url)}` })
  },
  "short_url": {
    _shortUrlId: (shortUrlId: string | number) => ({
      $url: (url?: { hash?: string }) => ({ pathname: '/short-url/[shortUrlId]' as const, query: { shortUrlId }, hash: url?.hash, path: `/short-url/${shortUrlId}${buildSuffix(url)}` })
    })
  },
  "signin": {
    $url: (url?: { hash?: string }) => ({ pathname: '/signin' as const, hash: url?.hash, path: `/signin${buildSuffix(url)}` })
  },
  "signup": {
    $url: (url?: { hash?: string }) => ({ pathname: '/signup' as const, hash: url?.hash, path: `/signup${buildSuffix(url)}` })
  },
  "under_review": {
    "edit": {
      $url: (url?: { hash?: string }) => ({ pathname: '/under-review/edit' as const, hash: url?.hash, path: `/under-review/edit${buildSuffix(url)}` })
    },
    $url: (url?: { hash?: string }) => ({ pathname: '/under-review' as const, hash: url?.hash, path: `/under-review${buildSuffix(url)}` })
  },
  $url: (url?: { hash?: string }) => ({ pathname: '/' as const, hash: url?.hash, path: `/${buildSuffix(url)}` })
};

export type PagesPath = typeof pagesPath;
